export const SIZES = {
  NAME: 28,
  CREATED: 37,
  UPDATED: 35,
};
